export interface TestScenario {
  name: string;
  fen: string;
  description: string;
  expectedMove?: string;
  priority?: string;
}

export const SAVED_SCENARIOS: TestScenario[] = [
  {
    name: "Kingrace A",
    fen: "8/3CK4/6bk1/8/8",
    description:
      "(0,1) AI should early exit to first immediate race victory option",
    priority: "Race Victory",
  },
  {
    name: "Kingrace B",
    fen: "8/R*7/1mk6/2MK5/8",
    description:
      "(0,2) the AI must take a second option with (0,1) blocked by enemy Rhino and ignore capturing the enemy king!",
    priority: "Race Victory",
  },
  {
    name: "Kingrace C",
    fen: "8/R*3C3/BKmk6/8/8",
    description:
      "(0,3) the AI must take a third option with (0,1) being a capture risk with Bear and (0,2) being blocked by enemy Rhino",
    priority: "Race Victory",
  },
  {
    name: "King capture A",
    fen: "G7/8/5bkCK1/8/8",
    description: "Ai must capture enemy king immediately on C2",
    priority: "Kingslayer",
  },
  {
    name: "Raceblock A",
    fen: "8/w3CK3/8/1b7/c7",
    description: "If player moves to B6, the AI moves to D8 to block access!",
    priority: "Raceblock",
  },
  {
    name: "Dontsetuprace A",
    fen: "8/4CK2wk/8/6Mb/6c1",
    description:
      "If player moves Monkey forward to C7, D7 or E7, the AI should never relinquish a block position that allows the enemy king to race immediately!",
    priority: "Raceblock",
  },
  {
    name: "Race disrupt A",
    fen: "8/8/6MK1/1bk1C1G2/c7",
    description:
      "If player moves monkey to D2, the Dark bear needs to vacate the leap chain to ensure the light Monkey king cannot race win immediately!",
    priority: "Raceblock",
  },
  {
    name: "Race disrupt B",
    fen: "8/8/6MK1/1C1bk1G2/c7",
    description:
      "Even with a free capture, the AI should still move out of the leap chain to ensure the enemy king cannot race win immediately!",
    priority: "Raceblock",
  },
  {
    name: "Race disrupt C",
    fen: "8/8/3SM1/1Ctbk2GK1/c7",
    description:
      "If the player moves the goat king up, the AI should prefer to break the traverse rather than get a free kill!",
    priority: "Raceblock",
  },
  {
    name: "Race disrupt D",
    fen: "8/1b1R*K4/5mk2/8/2C5",
    description:
      "This priority is pitting a major priority in disrupt (moving out of the rhino charge path to stop immediate race loss) against the 2-turn race victory priority with the dark monkey! The ai must elect to move the bear out of the way to not lose immediately!",
    priority: "Raceblock",
  },
  {
    name: "King safety move",
    fen: "6cC/2BK5/8/3mk4/8",
    description:
      "The AI should notice that the monkey safety trumps free captures and two turn race victories in this position (player move Bear toward monkey)",
    priority: "Raceblock",
  },
  {
    name: "Two turn race",
    fen: "6Cf*/2WK5/3ck4/7M/8",
    description:
      "Light should be unable to stop an unstoppable 2-turn race victory!",
    priority: "Two turn race",
  },
  {
    name: "Two turn race B",
    fen: "f*C6/5W2/4mk3/7BK/8",
    description: "Move bear to C2 - Monkey should leap and win!",
    priority: "Two turn race",
  },
  {
    name: "Mushroom - octopus free threat",
    fen: "bk6BK/8/3u1O2/8/8",
    description:
      "The AI should be incentivized to threaten, advance and make the octopus retreat with its advantage over Octopi's limited attack on non-animals!",
    priority: "Free threats",
  },
  {
    name: "goatsafetycheck",
    fen: "8/6c1/4BK1gk1/6c2/8",
    description:
      "Bear tutorial 4 scenario - Dark goat king at [6,2] should recognize it's in immediate danger from Light bear at [5,1] and move to safety immediately",
    priority: "King Safety",
  },
  {
    name: "Tree+Crane Victory Test",
    fen: "7T+C♛/w7/8/8/8",
    description:
      "Tree tutorial 2 test - Tree and Crane King stacked together on row 7 should trigger secret victory condition",
    priority: "Victory Detection",
  },
  {
    name: "Tree+Crane Setup Test",
    fen: "8/6T+CK1/4bk3/8/8",
    description:
      "Tree tutorial 2 setup - Tree and Crane King on row 6, next move should get them to row 7 for victory test",
    priority: "Victory Setup",
  },
  {
    name: "Monkey double test",
    fen: "8/8/2MKT4/3U4/7ck",
    description:
      "Testing Monkey treeswing",
    priority: "Victory Setup",
  },
  {
    name: "Virus test",
    fen: "2BK1bk3/1C1V1b2/8/1G1c1g2",
    description:
      "Testing virus",
    priority: "Victory Setup",
  },
  {
    name: "Pengwings test",
    fen: "8/8/PK6tk/8/8",
    description:
      "Testing pengwings",
    priority: "Victory Setup",
  },
];

export function getScenarioNames(): string[] {
  return SAVED_SCENARIOS.map((scenario) => scenario.name);
}

export function getScenarioByName(name: string): TestScenario | undefined {
  return SAVED_SCENARIOS.find((scenario) => scenario.name === name);
}
